export const SHIPPING_ADDRESS_FIELDS = {
  ADDRESS: 'shippingAddress',
  ATTENTION: 'shippingAddressAttention',
  CONTACT: 'shippingAddressContact',
};
